import { render, staticRenderFns } from "./ed-label.vue?vue&type=template&id=143c8720&scoped=true&"
import script from "./ed-label.ts?vue&type=script&lang=js&"
export * from "./ed-label.ts?vue&type=script&lang=js&"
import style0 from "./ed-label.scss?vue&type=style&index=0&id=143c8720&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143c8720",
  null
  
)

export default component.exports